import React, { useState } from "react";
import ReactDOM from "react-dom";
import RightAll from "./Main Content";

export default function SubbarContent(props) {
  const [name, setName] = useState('');

  function handleClick(name){
    setName(name)
  }
  return props.name.map((val) => {
    return (
      <>
        <div
          className="dashboard-content-list"
          id={val.name === name ? 'dashboard': ''}
        
          onClick={()=>{
            handleClick(val.name)
            ReactDOM.render( 
            <val.click />,
            document.getElementById("Right-content")
          )}}
        >
          {/* <img src={val.img} alt="" width="16px" /> */}
          <span>{val.icon}</span>
          <p>{val.name}</p>
        </div>
      </>
    );
  });
}
